import { gql } from "@apollo/client";

export const CREATE_CONVERSATION = gql`
  mutation CreateConversation($input: CreateConversationInput!) {
    createConversation(input: $input) {
      id
      isGroup
      groupName
      groupImage
      unreadCount
      participants {
        id
        name
        lastname
        profileImage
      }
      lastMessage {
        id
        text
        isSystemMessage
      }
      updatedAt
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation SendConversationMessage($input: SendMessageInput!) {
    sendConversationMessage(input: $input) {
      id
      text
      audioUrl
      fileUrls
      createdAt
      sender {
        id
        name
        lastname
        profileImage
      }
    }
  }
`;

export const SET_TYPING_STATUS = gql`
  mutation SetTypingStatus($input: TypingStatusInput!) {
    setTypingStatus(input: $input)
  }
`;

export const CREATE_GROUP_CONVERSATION = gql`
  mutation CreateGroupConversation($input: CreateGroupConversationInput!) {
    createGroupConversation(input: $input) {
      id
      isGroup
      groupName
      groupImage
      groupDescription
      participants {
        id
        name
        lastname
        profileImage
      }
      admins {
        id
        name
        lastname
      }
      createdBy {
        id
        name
        lastname
      }
    }
  }
`;

export const ADD_PARTICIPANTS_TO_GROUP = gql`
  mutation AddParticipantsToGroup($input: AddParticipantsInput!) {
    addParticipantsToGroup(input: $input) {
      id
      participants {
        id
        name
        lastname
        profileImage
      }
    }
  }
`;

export const REMOVE_PARTICIPANT_FROM_GROUP = gql`
  mutation RemoveParticipantFromGroup($input: RemoveParticipantInput!) {
    removeParticipantFromGroup(input: $input) {
      id
      participants {
        id
        name
        lastname
        profileImage
      }
    }
  }
`;

export const UPDATE_GROUP_INFO = gql`
  mutation UpdateGroupInfo($input: UpdateGroupInfoInput!) {
    updateGroupInfo(input: $input) {
      id
      groupName
      groupDescription
      groupImage
    }
  }
`;

export const LEAVE_GROUP = gql`
  mutation LeaveGroup($conversationId: String!) {
    leaveGroup(conversationId: $conversationId)
  }
`;

export const MARK_CONVERSATION_AS_READ = gql`
  mutation MarkConversationAsRead($conversationId: String!) {
    markConversationAsRead(conversationId: $conversationId)
  }
`;

export const CHAT_PRESENCE_HEARTBEAT = gql`
  mutation ChatPresenceHeartbeat {
    chatPresenceHeartbeat
  }
`;
